<base-button
  (btnClick)="goToContactUrl()"
  [size]="buttonSize.sm"
  [attr.data-cy]="'contacts-btn'"
  label="contact"
  color="white"
  class="btn-contact-white"
></base-button>
